import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import { useAuth } from '../context/AuthContext'
import { LoadingScreen } from '../components/LoadingScreen'

export function AuthCallbackPage() {
  const { status } = useAuth()
  const navigate = useNavigate()

  useEffect(() => {
    if (status === 'authenticated') navigate('/', { replace: true })
    if (status === 'unauthenticated') {
      // Amplify failed to complete the code exchange — push back to login.
      navigate('/login', { replace: true })
    }
  }, [status, navigate])

  return <LoadingScreen label="Finishing sign-in..." />
}
